module.exports = __webpack_public_path__ + "img/bank-money.1d21e3cd.png";